import { db } from '@/components/Firebase_Conn'
import Vue from 'vue'

// initial state
const state = {
  newRowListener: false,
  loaded: false,
  source: '',
  filters: {},
  tableRowsData: [],
  rightClickedRow: '',
  contextualMenu: {},
  lastElement: {}
}

// TODO : TROVARE UN MODO PER CREARE DINAMICAMENTE UN ARRAY tableRowsData SPECIFICO ALLA SORGENTE
// poi usare  </keep-alive> in app.vue per tenere in memoria in componente.
// SERVE A NON RISCARICARE OGNI VOLTA TUTTI DATI AL PASSAGGIO TRA UN PAGINA E L'ALTRA.

// getters
const getters = {
  // eslint-disable-next-line no-undef
  loaded: state => state.loaded,
  source: state => state.source,
  filters: state => state.filters,
  tableRowsData: state => state.tableRowsData,
  rightClickedRow: state => state.rightClickedRow,
  contextualMenu: state => state.contextualMenu,
  lastElement: (state, getters) => { // return state.tableRowsData[state.tableRowsData.length - 1]
    return state.tableRowsData[state.tableRowsData.length - 1]
  }
}

// actions
const actions = {
  destroyListeners({ commit, state, actions }, payload) {
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + payload.source
    this.databaseOps.db.ref(pointer).off()
  },
  newItemListener({ commit, state, actions }, payload) {
    var self = this
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + payload.source
    this.databaseOps.db.ref(pointer).orderByChild('_timestamp').limitToFirst(1).on('value', function (snapshot, prevChildKey) {
      if (snapshot.exists()) {
        snapshot.forEach((itemSnap) => {
          const item = itemSnap.val()
          if (item.timestamp !== undefined) {
            console.log('ok snap ok time')
            var timestamp = parseInt(item.timestamp) + 1
            self.databaseOps.db.ref(pointer).orderByChild('timestamp').startAt(timestamp).on('child_added', function (snapshot, prevChildKey) {
              var newChild = snapshot.val()
              state.tableRowsData.unshift(newChild)
            })
          } else {
            console.log(' ok snap NO time')
            self.databaseOps.db.ref(pointer).orderByChild('timestamp').startAt(new Date().getTime() + 1).on('child_added', function (snapshot, prevChildKey) {
              var newChild = snapshot.val()
              state.tableRowsData.unshift(newChild)
            })
          }
        })
      } else {
        // console.log('new no time')
        self.databaseOps.db.ref(pointer).orderByChild('timestamp').on('child_added', function (snapshot, prevChildKey) {
          var newChild = snapshot.val()
          state.tableRowsData.unshift(newChild)
          actions.dispatch('newItemListener', payload)
        })
      }
    })

    // Get the data on a post that has been removed
    // per ogni record cancellato devo compensare scaricando altrettanto nodi.
    // this.databaseOps.db.ref(pointer).off('child_removed')
    this.databaseOps.db.ref(pointer).on('child_removed', function (snapshot) {
      var deletedChild = snapshot.val()
      state.tableRowsData.forEach(function (element, index, array) {
        if (element.id === deletedChild.id) {
          array.splice(index, 1)
          // PER OGNI CHILD CANCELLATO NE SCARICO UN'ALTRO.
          self.dispatch('crudTableStates/loadMoreRows', payload)
        }
      })
    })
    // Get the data on a post that has been child_changed
    this.databaseOps.db.ref(pointer).on('child_changed', function (snapshot) {
      var childChanged = snapshot.val()
      state.tableRowsData.forEach(function (element, index, array) {
        if (element.id === childChanged.id) {
          Object.keys(childChanged).forEach(function (key) {
            Vue.set(array[index], key, childChanged[key])
          })
        }
      })
    })
  },
  loadMoreRows({ commit, state, getters, actions }, payload) {
    payload = {
      source: state.source,
      filters: {
        limitToFirst: 1,
        showMoreLimit: 1,
        lastTimeStamp: getters.lastElement._timestamp + 1
      }
    }
    this.dispatch('crudTableStates/getTableRowsData', payload)
  },
  getTableRowsData({ commit, state }, payload) {
    var self = this
    // console.log('getTableRowsData ok')
    commit('setSource', payload.source)
    commit('setFilters', payload.filters)
    state.loaded = false
    var filters = payload.filters
    var lastTs = filters.lastTimeStamp
    var limitTf = filters.limitToFirst
    var showMoreLimit = filters.showMoreLimit
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + payload.source
    if (lastTs === undefined) {
      state.tableRowsData = []
      // console.log('NO timestamp filter')
      this.databaseOps.db.ref(pointer).orderByChild('_timestamp').limitToFirst(parseInt(limitTf)).on('value', function (snapshot, prevChildKey) {
        snapshot.forEach((itemSnap) => {
          const item = itemSnap.val()
          commit('setTableRowsData', item)
        })
        self.databaseOps.db.ref(pointer).off('value')
        state.loaded = true
      })
    }
    if (lastTs !== undefined) {
      // console.log('timestamp filter ok')
      this.databaseOps.db.ref(pointer).orderByChild('_timestamp').startAt(parseInt(lastTs)).limitToFirst(parseInt(showMoreLimit)).on('value', function (snapshot, prevChildKey) {
        snapshot.forEach((itemSnap) => {
          const item = itemSnap.val()
          commit('setTableRowsData', item)
        })
        // console.log('child_addeds with tsf')
        self.databaseOps.db.ref(pointer).off('value')
        state.loaded = true
      })
    }
  }
}

// mutations
const mutations = {
  setSource(state, obj) {
    state.source = obj
  },
  setFilters(state, obj) {
    state.filters = obj
  },
  setTableRowsData(state, obj) {
    // FATTO COSI PERCHè NON DEVO MAI FARE OGGETTO DI OGGETTI . SOLO ARRAY DI OGGETTI.
    state.tableRowsData.push(obj)
  },
  rightClickedRow(state, key) {
    state.rightClickedRow = key
  },
  setContextualMenu(state, event) {
    state.contextualMenu = event
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
